import { createLucideIcon } from "lucide-react";

export const ArrowRight = createLucideIcon(
    "ArrowRight",
    [
        [
            "path",
            {
                d: "M10 4.6666L12.6262 7.29283C12.9596 7.62616 13.1262 7.79283 13.1262 7.99994C13.1262 8.20704 12.9596 8.37371 12.6262 8.70704L10 11.3333",
                key: "c63j4e",
            },
        ],
        [
            "path",
            {
                d: "M12.666 7.99987L2.66602 7.99987",
                key: "j2l8ko",
            },
        ],
    ],
);
